exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sr-only {\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important; /* 1 */\n  -webkit-clip-path: inset(50%) !important;\n          clip-path: inset(50%) !important; /* 2 */\n  height: 1px !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important; /* 3 */\n}\n", ""]);

// exports
